import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    errorMessage: null,

    registrationModalOpen: false,
    registrationErrorMessage: null,
    registrationLoading: false,

    loginLoading: false,
    loginErrorMessage: null,

    autoLoginLoading: false,
    autoLoginErrorMessage: null,
    autologinSuccess: false,

    registrationStatus: null,
    existingUserAvailableOrgs: null,
    existingUserUUID: null,

    emailRequestErrorMessage: null,
    emailRequestLoading: false,
    emailRequestSuccessMessage: false,
    payloadSubmitted: false,
};

const marketplaceSetupSlice = createSlice({
    name: "marketplaceSetup",
    initialState,
    reducers: {
        submitStripeMarketplaceInstallationRequest(state) {
            state.registrationLoading = true;
            state.registrationModalOpen = true;
            state.registrationErrorMessage = null;
            state.registrationStatus = null;
            state.existingUserUUID = null;
            state.payloadSubmitted = true;
        },
        submitStripeMarketplaceInstallationSuccess(state, action) {
            state.registrationLoading = false;
            state.registrationModalOpen = true;
            state.registrationErrorMessage = null;
            state.registrationStatus = action.payload.setupStatus;
            state.existingUserUUID = action.payload.userUUID;
        },
        submitStripeMarketplaceInstallationFailure(state, action) {
            state.registrationLoading = false;
            state.registrationModalOpen = true;
            state.registrationErrorMessage = action.payload;
            state.registrationStatus = null;
            state.existingUserUUID = null;
        },
        submitInitialLoginForExistingUserRequest(state) {
            state.loginLoading = true;
        },
        submitInitialLoginForExistingUserSuccess(state, action) {
            state.loginLoading = false;
            state.existingUserAvailableOrgs = action.payload.availableOrganizations;
        },
        submitInitialLoginForExistingUserFailure(state, action) {
            state.loginLoading = false;
            state.loginErrorMessage = action.payload;
        },
        createNewStripeOrgForExistingUserRequest(state) {
            state.registrationLoading = true;
            state.registrationModalOpen = false;
            state.registrationErrorMessage = null;
            state.registrationStatus = null;
            state.existingUserUUID = null;
            state.payloadSubmitted = true;
        },
        createNewStripeOrgForExistingUserSuccess(state) {
            state.registrationLoading = false;
            state.registrationModalOpen = false;
            state.registrationErrorMessage = null;
        },
        createNewStripeOrgForExistingUserFailure(state, action) {
            state.registrationLoading = false;
            state.registrationModalOpen = true;
            state.registrationErrorMessage = action.payload;
            state.registrationStatus = null;
            state.existingUserUUID = null;
        },
        connectNewStripeAccountToExistingOrgRequest(state) {
            state.registrationLoading = true;
            state.registrationModalOpen = false;
            state.registrationErrorMessage = null;
            state.registrationStatus = null;
            state.existingUserUUID = null;
            state.payloadSubmitted = true;
        },
        connectNewStripeAccountToExistingOrgSuccess(state) {
            state.registrationLoading = false;
            state.registrationModalOpen = false;
            state.registrationErrorMessage = null;
        },
        connectNewStripeAccountToExistingOrgFailure(state, action) {
            state.registrationLoading = false;
            state.registrationModalOpen = true;
            state.registrationErrorMessage = action.payload;
            state.registrationStatus = null;
            state.existingUserUUID = null;
        },
        resendStripeEmailRequest(state) {
            state.emailRequestLoading = true;
            state.emailRequestSuccessMessage = null;
            state.emailRequestErrorMessage = null;
        },
        resendStripeEmailSuccess(state) {
            state.emailRequestLoading = false;
            state.emailRequestSuccessMessage = "Registrierungs-E-Mail erfolgreich gesendet";
            state.emailRequestErrorMessage = null;
        },
        resendStripeEmailFailure(state, action) {
            state.emailRequestLoading = false;
            state.emailRequestSuccessMessage = null;
            state.emailRequestErrorMessage = action.payload;
        },
        setPasswordMismatchError(state) {
            state.registrationErrorMessage = "Die Passwörter müssen übereinstimmen";
        },
        setUserMismatchError(state) {
            state.registrationErrorMessage =
                "Der angemeldete Benutzer stimmt nicht mit dem Stripe-Kontobenutzer überein";
        },
        clearErrorMessages(state) {
            state.registrationErrorMessage = null;
            state.errorMessage = null;
        },
        closeRegistrationModal(state) {
            state.registrationLoading = false;
            state.registrationModalOpen = false;
        },
    },
});

export default marketplaceSetupSlice;
